/*
 * @Author: jikeychang@gmail.com
 * @Date: 2021-03-03 17:48:37
 * @LastEditors: zerui.yao
 * @LastEditTime: 2022-12-08 16:49:41
 * @Description: FileDescription
 */

import db from '@/api/dbWeb';

const model = {
  // 获取ecarx外部组织
  getEcarxExternalTree(param) {
    return db.get('department/selectTree', param);
  },
  // 获取组织树
  getDeptListTree(param) {
    return db.get('department/tree', param);
  },
  // 用户详情
  getUserInfo(param) {
    return db.get('user/detail', param);
  },
  // 新组织树
  getDeptListTreeNew(param) {
    return db.get('/department/search', param);
  },
  // 搜索人员
  getUserListTree(param) {
    return db.post('/user/listDeptUser', param);
  },
};
export default model;
